// Enhanced data structure updated with LinkedIn profile insights
export const personalInfo = {
  name: "Julie Adams",
  title: "Fractional CMO & Strategic Marketing Operations Leader",
  headline: "Brand Positioning • Marketing Operations • Digital Experience • AI Orchestration",
  subHeadline: "Author of 'Brand Like A Girl' | Founder of SEVEN HATS® | 16+ Years Scaling JAC Marketing",
  email: "julie@julie-adams.com",
  calendar: "https://calendar.app.google/fEc5DqiofeUeHyRG6",
  phone: "404-793-9923",
  linkedin: "https://www.linkedin.com/in/julieadamsmsdm/",
  website: "https://sevenhats.com",
  agency: "https://sevenhats.com",
  jacMarketing: "https://jac-marketing.com",
  photo: "https://media-manager-c.questera.ai/greta-media/fb12f51ee5b6b5b04fc36e6e38322fdbe9f21a5255319993208ee42085da62af087180258d5c6d79d895c821bb9cc720/images/aW1hZ2UvcG5n/cf69406d1fff118a85e8aa1419f17a75.png",
  book: {
    title: "Escaping The Tool Trap™",
    fullTitle: "Escaping The Tool Trap™: The Systematic Approach to Martech Consolidation",
    description: "My book provides the complete playbook: frameworks, templates, scorecards, and real case studies from successful consolidations. From calculating TCO to establishing governance that prevents backsliding, you'll get everything you need to escape The Tool Trap™ and stay free forever.",
    cover: "/ETT_Photoshoot_Room.png",
    amazonLink: "https://www.paypal.com/ncp/payment/6YXHEXV5W8KVL"
  }
};

export const metrics = [
  { label: "Years Scaling Brands", value: "16+", icon: "FiCalendar" },
  { label: "Manufacturing Revenue Impact", value: "$2B+", icon: "FiBriefcase" },
  { label: "Avg. Operational Efficiency Lift", value: "40%", icon: "FiTrendingUp" },
  { label: "Strategic Briefings Delivered", value: "500+", icon: "FiTarget" }
];

export const executiveMetrics = [
  { label: "Market Share Growth", value: "+12.4%", trend: "up", period: "Q3 vs Q4" },
  { label: "Customer Acquisition Cost", value: "-18.2%", trend: "down", period: "Last 90 Days" },
  { label: "Operational ROI", value: "4.2x", trend: "up", period: "Annualized" },
  { label: "Brand Equity Score", value: "92/100", trend: "up", period: "Post-Rebrand" }
];

export const quarterlyReports = [
  {
    id: "q4-2023",
    title: "Q4 Strategic Performance Audit",
    date: "Dec 2023",
    status: "Published",
    keyFinding: "Consolidation of the MarTech stack resulted in a 22% reduction in operational friction."
  },
  {
    id: "q3-2023",
    title: "Q3 Brand Positioning Report",
    date: "Sept 2023",
    status: "Archived",
    keyFinding: "Audience sentiment shifted +30% following the 'Setting the Stage' implementation."
  }
];

export const expertise = [
  {
    title: "Fractional CMO Leadership",
    description: "Building marketing functions from the ground up for B2B SaaS and growth-stage companies with a focus on accountability.",
    icon: "FiUsers"
  },
  {
    title: "Marketing Operations",
    description: "Implementing LEAN and OKR frameworks to turn operational chaos into strategic clarity and measurable outcomes.",
    icon: "FiSettings"
  },
  {
    title: "Brand Architecture",
    description: "Shaping narratives for Grammy-winning artists, Fortune 500 executives, and national media companies.",
    icon: "FiLayers"
  },
  {
    title: "AI & Tech Orchestration",
    description: "Diagnosing tool traps and deploying AI-powered intelligence platforms like SEVEN HATS® to bridge MarkOps and Marketing Strategy.",
    icon: "FiCpu"
  }
];

export const testimonials = [
  {
    quote: "Julie’s approach to brand positioning is unmatched. She helped me perfectly align my personal influence with corporate objectives without losing my authentic voice. Setting the stage for success is exactly what she does.",
    author: "Hazely L",
    position: "USA Petite Founder, Slimfast Lead Brand Ambassador & Disney Actress",
    image: "/hazely.jpeg"
  },
  {
    quote: "Julie's ability to untangle our marketing stack and operationalize our data was nothing short of miraculous. She bridges the gap between MarkOps and Marketing Strategy seamlessly, acting as the true catalyst for our recent growth.",
    author: "Kenji T",
    position: "VP of Digital Strategy, Enterprise Solutions",
    image: "/asian-male.jpg"
  },
  {
    quote: "Working with Julie on the Zac Brown Band and other clients was a masterclass in brand strategy. She truly understands the intersection of culture, media, and commerce, building architectures that empower artists and brands alike.",
    author: "Jenna G",
    position: "Cox Media",
    image: "/jenna.jpeg"
  }
];

export const caseStudies = [
  {
    id: "cs-agentic-ai",
    client: "High-Growth SaaS Provider",
    title: "Automating Strategy: Agentic AI Deployment",
    category: "AI Orchestration",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2070&auto=format&fit=crop",
    summary: "Orchestrated autonomous Agentic AI workflows to revolutionize customer onboarding and personalized marketing at scale.",
    challenge: {
      text: "The marketing and customer success teams were overwhelmed by manual data processing and generic onboarding flows, leading to high churn rates. The lack of personalized experiences and delayed responses resulted in a poor customer experience.",
      bullets: [
        "Manual data entry causing bottlenecks and errors.",
        "Generic onboarding flows failing to address specific user needs.",
        "Delayed response times leading to customer frustration.",
        "High churn rates due to lack of engagement."
      ]
    },
    solution: {
      text: "Architected an Agentic AI ecosystem that autonomously analyzes user behavior, dynamically adjusts onboarding journeys, and executes personalized marketing interventions. This system leverages advanced machine learning models to predict user intent and automate targeted communications.",
      bullets: [
        "Deployed autonomous AI agents to handle repetitive tasks.",
        "Implemented dynamic, behavior-driven onboarding sequences.",
        "Integrated real-time analytics to trigger personalized interventions.",
        "Established a continuous learning loop to improve AI decision-making."
      ]
    },
    results: ["60% reduction in manual onboarding tasks", "25% increase in customer retention", "Hyper-personalized messaging delivered at scale"],
    tech: ["Agentic AI", "SEVEN HATS®", "Workflow Automation", "Machine Learning"],
    isNew: true
  },
  {
    id: "cs-aeo-geo",
    client: "Global E-Commerce Enterprise",
    title: "Future-Proofing Search: AEO & GEO Implementation",
    category: "AI Orchestration",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=2070&auto=format&fit=crop",
    summary: "Transitioned traditional SEO strategies into a comprehensive Answer Engine Optimization (AEO) and Generative Engine Optimization (GEO) framework to capture AI-driven search traffic.",
    challenge: {
      text: "With the rise of AI search engines and zero-click results, the client was experiencing a decline in top-of-funnel organic traffic despite high traditional SEO rankings. This shift required a fundamental change in how content was structured and optimized to remain visible in emerging search ecosystems.",
      bullets: [
        "Decline in top-of-funnel organic traffic.",
        "Increasing prevalence of zero-click search results.",
        "Traditional SEO strategies becoming less effective.",
        "Need to adapt to AI-driven search engines (AEO/GEO)."
      ]
    },
    solution: {
      text: "Deployed a strategic AEO/GEO architecture, restructuring content to directly answer intent-based queries and optimizing data structures for LLM consumption. This approach ensured the brand remained authoritative and discoverable across all conversational AI and traditional search platforms.",
      bullets: [
        "Restructured content to focus on answering specific user intents.",
        "Implemented advanced structured data for better LLM parsing.",
        "Developed a strategy for capturing featured snippets and voice search.",
        "Created an AI analytics framework to monitor visibility changes."
      ]
    },
    results: ["120% increase in AI search visibility", "45% boost in featured snippet capture", "Recovered top-of-funnel traffic within 90 days"],
    tech: ["AEO/GEO Frameworks", "LLM Optimization", "Structured Data", "AI Analytics"],
    isNew: true
  },
  {
    id: "cs-manufacturing",
    client: "$2B Manufacturing Organization",
    title: "The $80K Tool Trap™: Reclaiming Operational Sanity",
    category: "Operations",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?q=80&w=2070&auto=format&fit=crop",
    summary: "Diagnosed and solved the hidden chaos of disconnected tools and fragmented data inside a multi-billion dollar manufacturing firm.",
    challenge: {
      text: "The marketing team was drowning in 15+ disconnected tools, leading to $80k in annual redundant spend and a complete lack of data integrity. This fragmented ecosystem created operational silos, hindering the ability to track ROI and execute cohesive campaigns.",
      bullets: [
        "Over 15 disconnected marketing and sales tools.",
        "$80,000+ in annual redundant software spend.",
        "Lack of a unified data schema causing reporting inaccuracies.",
        "Poor alignment and communication between MarkOps and Marketing Strategy."
      ]
    },
    solution: {
      text: "Implemented the SEVEN HATS® methodology and LEAN frameworks to consolidate the tech stack and bridge the gap between MarkOps and Marketing Strategy. By mapping out workflows and identifying redundancies, we streamlined operations and established a single source of truth for marketing data.",
      bullets: [
        "Conducted a comprehensive audit to identify tool redundancies.",
        "Consolidated platforms to create a unified data ecosystem.",
        "Applied LEAN principles to eliminate waste in marketing processes.",
        "Facilitated cross-functional alignment between MarkOps and Marketing Strategy."
      ]
    },
    results: ["$80,000+ reclaimed in annual waste", "Unified data schema established", "35% increase in team output velocity"],
    tech: ["SEVEN HATS®", "HubSpot", "Salesforce", "LEAN Framework"],
    isNew: true
  },
  {
    id: "cs-entertainment",
    client: "Multi-Platinum Producer & Grammy-Award Artists",
    title: "Artist-Owned Media & Merch E-commerce Architecture",
    category: "Brand Strategy",
    image: "/ZBB.png",
    summary: "Architected a comprehensive artist-owned media and merchandise ecosystem for multi-platinum producers and Grammy-award winning talent, integrating global e-commerce infrastructures with synchronized streaming analytics and automated marketing frameworks.",
    challenge: {
      text: "High-profile production entities required a transition from platform-dependent revenue models to robust, artist-owned infrastructure without sacrificing brand prestige or audience engagement. They needed to control their narrative and monetize their fanbase directly, bypassing traditional intermediaries.",
      bullets: [
        "Over-reliance on third-party platforms for revenue.",
        "Lack of direct access to fan data and engagement metrics.",
        "Need to maintain high brand prestige during the transition.",
        "Requirement for a scalable infrastructure to handle global traffic."
      ]
    },
    solution: {
      text: "Built a bespoke artist-owned media and merchandise e-commerce platform integrated with real-time streaming analytics and automated marketing architecture. This ecosystem empowered the artists to own their audience data and deliver exclusive, personalized experiences.",
      bullets: [
        "Architected a scalable, custom e-commerce platform for media and merch.",
        "Integrated real-time streaming data for targeted marketing campaigns.",
        "Developed automated marketing funnels to nurture fan relationships.",
        "Established secure data ownership protocols for the artists."
      ]
    },
    results: ["300% growth in direct-to-fan revenue", "Unified fan data ownership established", "Successful global infrastructure launch"],
    tech: ["E-commerce Engineering", "Streaming Data Integration", "Marketing Architecture"],
    isNew: false
  },
  {
    id: "cs-media",
    client: "National Media Company",
    title: "Orchestrating Digital Transformation for Media",
    category: "Operations",
    image: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?q=80&w=2070&auto=format&fit=crop",
    summary: "Streamlining operations across a national media portfolio to drive engagement and conversion.",
    challenge: {
      text: "Fragmented viewer data and siloed marketing efforts across 50+ regional hubs were hindering growth. The lack of centralized intelligence made it impossible to execute national campaigns effectively or measure the true impact of marketing spend.",
      bullets: [
        "Siloed marketing efforts across 50+ regional hubs.",
        "Fragmented viewer data preventing a unified customer view.",
        "Inability to execute and measure national campaigns effectively.",
        "Lack of a standardized framework for setting and tracking goals."
      ]
    },
    solution: {
      text: "Implemented a unified Marketing Operations framework and OKR-based accountability system. This initiative centralized data intelligence, streamlined campaign execution, and fostered a culture of performance and accountability across all regional hubs.",
      bullets: [
        "Deployed a centralized Marketing Operations framework.",
        "Established an OKR-based system for goal alignment and tracking.",
        "Integrated fragmented data sources into a unified intelligence platform.",
        "Standardized campaign workflows to reduce time-to-market."
      ]
    },
    results: ["40% reduction in campaign time-to-market", "Centralized data intelligence", "Measurable lift in viewer retention"],
    tech: ["OKR Framework", "Marketing Tech Stack", "Data Orchestration"],
    isNew: false
  },
  {
    id: "cs-f500",
    client: "Fortune 500 Brand Ambassadors",
    title: "Scaling Influence: Strategic Brand Alignment",
    category: "Brand Strategy",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop",
    summary: "Helping brand ambassadors for Fortune 500 consumer brands align their personal influence with corporate objectives.",
    challenge: {
      text: "Ambassadors struggled to maintain individual brand integrity while meeting high-level corporate KPIs. The misalignment between personal brand voice and corporate messaging often resulted in inauthentic content and diminished influence.",
      bullets: [
        "Difficulty balancing personal brand voice with corporate messaging.",
        "Struggles to meet high-level corporate KPIs authentically.",
        "Risk of diminishing individual influence due to misaligned content.",
        "Lack of a clear framework for navigating the ambassador role."
      ]
    },
    solution: {
      text: "Created a strategic positioning framework that balanced personal brand power with executive strategic clarity. This framework provided ambassadors with the tools and guidance to align their authentic voice with corporate objectives, driving mutual value.",
      bullets: [
        "Developed a custom strategic positioning framework for ambassadors.",
        "Provided executive coaching to align personal and corporate goals.",
        "Designed content architectures that maintained authentic voice.",
        "Established clear metrics for measuring mutually beneficial success."
      ]
    },
    results: ["100% KPI alignment achieved", "Increased partnership longevity", "Elevated executive presence"],
    tech: ["Strategic Positioning", "Executive Coaching", "Content Architecture"],
    isNew: false
  }
];

export const resources = [
  {
    id: "res-1",
    title: "The $80K Tool Trap™ Audit",
    description: "A self-assessment guide to identifying redundant SaaS spend and operational bottlenecks.",
    type: "Audit Template",
    category: "Operations",
    icon: "FiSearch",
    isNew: true,
    url: "#"
  },
  {
    id: "res-2",
    title: "Brand Like A Girl: Executive Summary",
    description: "Key takeaways from the strategic framework for building authentic, powerful brands.",
    type: "Executive Summary",
    category: "Strategy",
    icon: "FiBook",
    isNew: false,
    url: "#"
  },
  {
    id: "res-3",
    title: "LEAN Marketing Implementation",
    description: "How to apply LEAN principles to your marketing function to create measurable outcomes.",
    type: "Whitepaper",
    category: "Operations",
    icon: "FiBarChart",
    isNew: false,
    url: "#"
  },
  {
    id: "res-4",
    title: "MarTech Consolidation ROI Calculator",
    description: "Interactive tool to calculate potential savings and efficiency gains by eliminating redundant marketing technologies.",
    type: "Interactive Tool",
    category: "Interactive",
    icon: "FiDollarSign",
    isNew: true,
    url: "#"
  },
  {
    id: "res-5",
    title: "Orchestrating AI in Marketing Ops",
    description: "Deep dive into creating intelligent automation loops that multiply output without expanding headcount.",
    type: "Blog Article",
    category: "Blog",
    icon: "FiCpu",
    isNew: true
  }
];

export const pressMentions = [
  {
    id: "press-1",
    title: "Setting the Stage for SUCCESS: A New Era of Branding",
    publisher: "Executive Leadership Magazine",
    type: "Feature",
    date: "November 2023",
    link: "#",
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095?q=80&w=2069&auto=format&fit=crop"
  },
  {
    id: "press-2",
    title: "Why CMOs Must Bridge the Gap Between MarkOps and Marketing Strategy",
    publisher: "SaaS Growth Podcast",
    type: "Podcast",
    date: "September 2023",
    link: "#",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=2070&auto=format&fit=crop"
  }
];

export const careerHistory = [
  {
    role: "Fractional CMO & Founder",
    company: "SEVEN HATS®",
    period: "Present",
    description: "Developing an AI-powered strategic intelligence platform and providing fractional leadership to growth-stage companies."
  },
  {
    role: "Founder & CEO",
    company: "JAC Marketing",
    period: "16 Years",
    description: "Built and scaled a premier agency shaping brand strategy for Grammy-winning artists, F500 execs, and national media companies."
  },
  {
    role: "Strategic Marketing Operations Leader",
    company: "$2B Manufacturing Organization",
    period: "Strategic Engagement",
    description: "Diagnosed the $80k Tool Trap™ and implemented LEAN frameworks to optimize the global marketing technology ecosystem."
  },
  {
    role: "Strategic Consultant",
    company: "Field Ethos Journal",
    period: "Strategic Engagement",
    description: "Guided strategic brand positioning and operational workflows to optimize audience engagement and digital media presence."
  },
  {
    role: "Strategic Consultant",
    company: "IT-Remote",
    period: "Strategic Engagement",
    description: "Advised on market positioning and go-to-market operations for robust cloud and edge computing systems targeting enterprise corporations."
  }
];

export const techStack = [
  "SEVEN HATS® Platform",
  "LEAN Frameworks",
  "OKR Methodologies",
  "HubSpot Enterprise",
  "Salesforce",
  "Marketo",
  "AI Orchestration Tools",
  "Digital Experience Design",
  "Marketing Automation",
  "Strategic Intelligence"
];
